<template>
  <el-dialog
    title="找回密码"
    :visible.sync="visible"
    width="470px"
    show-close
    :before-close="beforeClose"
    @closed="closed"
  >
    <el-alert title="请输入用户名，我们会将密码修改链接发送到您注册时的邮箱" type="info" show-icon :closable="false" class="marginBottom20"></el-alert>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
      <el-form-item label="用户名" prop="loginName">
        <el-input v-model="ruleForm.loginName" placeholder="请输入用户名"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitForm" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { validatenull } from '@/util/validate'
  import { userResetPassword } from '@/api/user/login'
  
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        ruleForm: {
          loginName: ''
        },
        rules: {
          loginName: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      resetForm() {
        if (this.$refs.ruleForm !== undefined) {
          this.ruleForm = {
            loginName: ''
          }
          this.$refs.ruleForm.resetFields();
        }
      },
      beforeClose(done) {
        done()
        this.$emit('update:visible', false)
      },
      handleClose() {
        this.$emit('update:visible', false)
      },
      closed() {
        this.resetForm()
      },
      submitForm() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.loading = true
            const params = {
              mainForm: {
                ...this.ruleForm
              }
            }
            userResetPassword(params).then(res => {
              this.loading = false
              if (res.data.code == 0) {
                this.$message.success("发送成功")
                this.handleClose()
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch((error) => {
              this.loading = false
            })
          }
        })
      }
    }
  };
</script>

<style scoped>
  .dialog-footer {
    text-align: right;
  }
</style>
